const paintActions = {
  PUSH_ITEM_TO_STORE_ON_INITIAL_RENDER: 'PUSH_ITEM_TO_STORE_ON_INITIAL_RENDER',
  CLEAR_PAINT_ARRAY: 'CLEAR_PAINT_ARRAY',
};

export { paintActions };
